import { useState, useCallback } from 'react'
import { instance } from 'services'

export const useAvatar = () => {
  const [avatarImage, setAvatarImage] = useState<string>('')
  const [avatarFile, setAvatarFile] = useState<File | null>(null)

  const resolveAvatarUrl = useCallback((url?: string | null) => {
    if (!url) return ''
    if (/^https?:\/\//i.test(url)) return url
    const base = String(instance.defaults.baseURL || '').replace(/\/+$/, '')
    const path = url.replace(/^\/+/, '')
    return base ? `${base}/${path}` : `/${path}`
  }, [])

  const handleFileSelect = useCallback((file: File) => {
    setAvatarImage(URL.createObjectURL(file))
    setAvatarFile(file)
  }, [])

  const getAvatar = useCallback((profile: any) => {
    if (avatarFile !== null) {
      return avatarFile
    }

    if (typeof profile?.avatar === 'string' && profile.avatar.length > 0) {
      return resolveAvatarUrl(profile.avatar)
    }

    return ''
  }, [avatarFile, resolveAvatarUrl])

  const resetAvatar = useCallback(() => {
    setAvatarImage('')
    setAvatarFile(null)
  }, [])

  return {
    avatarImage,
    avatarFile,
    setAvatarImage,
    setAvatarFile,
    resolveAvatarUrl,
    handleFileSelect,
    getAvatar,
    resetAvatar,
  }
}


